import * as React from "react"
import * as ReactDom from "react-dom"
import * as Bouncer from "formbouncerjs";
import Contacto from "../components/views/Contact";
import { emails } from "../config/constants";
import { setCurrentPage } from "../services/general";

export const page = async () => {
    let language = window.currentLang
    ReactDom.render(<Contacto title={language == 'en' ? 'Contact' : 'Contacto'} desc={language == 'en' ? 'Contact us and we protect the aquifers of Calera and APAN together' : 'Contáctanos y protejamos juntos los acuíferos de Calera y Apan'} />, document.getElementById('contacto'))
    setNewForm(language)
    validateForm(language)
    hideEmptyOptions()
    setCurrentPage('contact')
}

function hideEmptyOptions() {
    const options = document.querySelectorAll(".form-select option") as NodeListOf<HTMLOptionElement>;
    options.forEach((opt) => {
        if (!opt.innerHTML) {
            opt.style.display = "none";
        }
    });
}

function setNewForm(lang: string) {
    const refForm = document.getElementById('refFormContact') as HTMLFormElement;
    const refNewForm = document.getElementById('newFormContact') as HTMLFormElement;
    if (lang === 'en') {
        refNewForm.insertAdjacentElement('beforeend', refForm.children[0])
    }
    else if (lang === 'es') {
        refNewForm.insertAdjacentElement('beforeend', refForm.children[1])
    }
    refForm.remove()
    selectOnChange()
}

function validateForm(lang: string) {
    let validationsMessages: any = {
        en: {
            field: 'Obligatory field',
            email: 'Please enter a valid email',
            phone: 'Only 7 to 10 digits are allowed',
            tyc: 'You must accept terms and conditions'
        },
        es: {
            field: 'Campo Obligatorio',
            email: 'Por favor ingrese un email válido',
            phone: 'Solo se permiten 7 a 10 digitos',
            tyc: 'Debe aceptar términos y condiciones'
        }
    }
    var validate = Bouncer("form:not(.newsletter-form)", {
        patterns: {
            email:
                /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
        },
        customValidations: {
            emailVerified: function (field: any) {
                let array_email = field.value.split("@");
                const res = emails.find((m) => m === array_email[1]);
                return res === undefined ? false : true;
            },
            phoneVerified: function (field: any) {
                if (field.name == "cellphone" || field.name == "cellphone_en") {
                    if (field.hasAttribute('required')) {
                        const value = field.value;
                        if (value.length < 7 || value.length > 10) {
                            return true;
                        }
                    }
                }
            },
            anotherVerified: function (field: any) {        
                if(field.name == "other") {
                    const value = field.value;
                    if (value.length < 1) {
                        return true;
                    }
                }
            }
        },
        messages: {
            missingValue: {
                default: validationsMessages[lang].field,
                checkbox: validationsMessages[lang].tyc,
            },
            emailVerified: validationsMessages[lang].email,
            phoneVerified: validationsMessages[lang].phone,
            anotherVerified: validationsMessages[lang].field,
            patternMismatch: {
                email: validationsMessages[lang].email,
            },
        },
    });
}

function selectOnChange() {
    let refSelect = document.getElementById('edit-sector') || document.getElementById('edit-sector--2')
    let refPhone = document.getElementById('edit-cellphone') || document.getElementById('edit-cellphone--2')
    let refEmail = document.getElementById('edit-email') || document.getElementById('edit-email--2')
    let refOther = document.getElementById('edit-other') || document.getElementById('edit-other--2') 

    refPhone && refPhone.removeAttribute('required')
    refEmail && refEmail.setAttribute('required', 'required')

    if (refSelect) {
        refSelect.addEventListener('change', (e) => {
            let selectTarget = e.target as HTMLSelectElement;
            if (parseInt(selectTarget.value) > 3) {
                refPhone && refPhone.setAttribute('required', 'required')
                refEmail && refEmail.removeAttribute('required')
            }
            else {
                refPhone && refPhone.removeAttribute('required')
                refEmail && refEmail.setAttribute('required', 'required')
            }

            if (parseInt(selectTarget.value) == selectTarget.length - 1) {
                refOther && refOther.setAttribute('required', 'required')
                refOther && refOther.removeAttribute('disabled')

            } else {
                refOther && refOther.removeAttribute('required')
                refOther && refOther.setAttribute('disabled', 'disabled')
            }
        })
    }
}
